export default {
      id: "oc-menu-game-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-game",
      toString: function () {
        return this.url;
      }
    }